// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════════════
   SISTEMA DE MODALES — CLEAN BLUE
   ═══════════════════════════════════════════════════════════════════════════
   Este CSS rediseña las clases base que comparten TODOS los modales
   \`card-modal-gs\`. Cambiar este archivo aplica el nuevo estilo a:
     - ModalCreateService
     - Cualquier otro modal que use .card-modal-gs / .head-card-modal-gs /
       .content-card-modal-gs / .form-GS-box / .user-box-GS / .label-GS
   
   Paleta usada:
     --cb-blue:        #1a56db   (primario)
     --cb-blue-dark:   #0f2d5e   (header azul marino)
     --cb-blue-soft:   #e8f0fe   (focus, fondos suaves)
     --cb-text:        #0f172a
     --cb-text-2:      #334155
     --cb-text-3:      #64748b
     --cb-border:      #e2e8f0
     --cb-bg:          #f8fafc
     --cb-bg-2:        #f1f5f9
     --cb-white:       #ffffff
     --cb-red:         #e02424
     --cb-red-soft:    #fef2f2
   ═══════════════════════════════════════════════════════════════════════════ */


/* ── Compatibilidad con clases antiguas (no se tocan) ────────────────────── */
.card-users.modal-verificate {
  width: 100% !important;
  height: 99% !important;
}

.content-card-users {
  height: 94%;
}

.txt-title-user-box-Mantto.modal-verificate {
  text-align: center;
  word-wrap: break-word;
  width: 80%;
}


/* ═══════════════════════════════════════════════════════════════════════════
   FONDO OSCURO DEL MODAL
   ═══════════════════════════════════════════════════════════════════════════ */
.modal-GS-content {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
}


/* ═══════════════════════════════════════════════════════════════════════════
   TARJETA DEL MODAL
   ═══════════════════════════════════════════════════════════════════════════ */
.card-modal-gs {
  position: relative;
  display: flex;
  flex-direction: column;
  /* width: 90%;
  max-width: 560px;
  max-height: 92vh; */
  z-index: 1;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  outline: none;
  box-shadow: 0 20px 60px rgba(15, 45, 94, 0.25),
    0 4px 12px rgba(15, 45, 94, 0.08);
}

.card-modal-gs.modal-verificate {
  width: 100% !important;
  /* max-width: 560px !important; */
  height: 100% !important;
  /* max-height: 92vh !important; */
}


/* ═══════════════════════════════════════════════════════════════════════════
   HEADER AZUL MARINO
   ═══════════════════════════════════════════════════════════════════════════ */
.head-card-modal-gs {
  position: relative;
  height: auto;
  min-height: 56px;
  width: 100%;
  background: #0f2d5e;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 14px 20px;
  flex-shrink: 0;
  gap: 12px;
  box-sizing: border-box;
}

.title-head-card-modal-gs {
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: none;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Botón X opcional — agregar al JSX con esta clase si se desea: */
.close-card-modal-gs {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  transition: background 0.15s ease;
  flex-shrink: 0;
}

.close-card-modal-gs:hover {
  background: rgba(255, 255, 255, 0.18);
}


/* ═══════════════════════════════════════════════════════════════════════════
   CUERPO DEL MODAL
   ═══════════════════════════════════════════════════════════════════════════ */
.content-card-modal-gs {
  position: relative;
  height: auto;
  flex: 1 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding: 24px;
  box-sizing: border-box;
  background: #f8fafc;
  overflow-y: auto;
  scrollbar-width: thin;
}


/* ═══════════════════════════════════════════════════════════════════════════
   FORMULARIO — Layout vertical limpio con gap (no más alturas en %)
   ═══════════════════════════════════════════════════════════════════════════ */
.form-GS-box {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  max-width: 480px;
  height: auto;
}


/* ═══════════════════════════════════════════════════════════════════════════
   CAMPO DE FORMULARIO — Label arriba, input abajo (altura fija 36px)
   ═══════════════════════════════════════════════════════════════════════════ */
.form-GS-box .user-box-GS {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  height: auto !important;
  gap: 6px;
}

/* El último user-box-GS suele ser el contenedor de botones — más espacio arriba */
.form-GS-box .user-box-GS:last-child {
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  padding-top: 18px;
  border-top: 1px solid #e2e8f0;
}


/* ═══════════════════════════════════════════════════════════════════════════
   LABEL — Posición normal arriba del input (no más absolute flotante)
   ═══════════════════════════════════════════════════════════════════════════ */
.form-GS-box .user-box-GS .label-GS {
  position: relative;
  top: 0;
  left: 0;
  padding: 0;
  font-size: 12px !important;
  font-weight: 600;
  color: #0f2d5e;
  pointer-events: none;
  transition: none;
  display: flex;
  align-items: center;
  gap: 4px;
  letter-spacing: 0.02em;
}

/* Estados focus/valid que antes movían el label — ahora no hace falta animar
   pero los dejamos compatibles para no romper nada */
.form-GS-box .user-box-GS input:focus~.label-GS,
.form-GS-box .user-box-GS input:valid~.label-GS,
.form-GS-box .user-box-GS .active {
  top: 0 !important;
  left: 0;
  font-size: 12px !important;
  color: #0f2d5e;
}


/* ═══════════════════════════════════════════════════════════════════════════
   INPUTS — Altura fija, borde fino, focus azul
   ═══════════════════════════════════════════════════════════════════════════ */
.form-GS-box .user-box-GS input {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  font-size: 13px;
  color: #0f172a;
  border: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  border-radius: 8px;
  outline: none;
  background: #ffffff;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  margin: 0;
}

.form-GS-box .user-box-GS input::placeholder {
  color: #94a3b8;
  font-size: 13px;
  font-weight: 400;
}

.form-GS-box .user-box-GS input:hover:not(:disabled) {
  border-color: #cbd5e1;
}

.form-GS-box .user-box-GS input:focus {
  border-color: #1a56db;
  box-shadow: 0 0 0 3px rgba(26, 86, 219, 0.15);
}

.form-GS-box .user-box-GS input:disabled {
  background: #f1f5f9;
  color: #64748b;
  cursor: not-allowed;
}


/* ═══════════════════════════════════════════════════════════════════════════
   MENSAJE DE ERROR
   ═══════════════════════════════════════════════════════════════════════════ */
.form-msg-error-gs {
  display: block;
  margin-top: 4px;
  padding: 6px 10px;
  background: #fef2f2;
  border: 1px solid #fee2e2;
  color: #e02424;
  font-size: 12px;
  border-radius: 6px;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  top: 0;
  left: 0;
}

/* Versión anterior (banner ancho) — compatibilidad */
.form-msg-error {
  color: #e02424;
  position: relative;
  top: 0;
  left: 0;
  background-color: #fef2f2;
  width: 100%;
  text-align: left;
  padding: 6px 10px;
  border: 1px solid #fee2e2;
  border-radius: 6px;
  margin-top: 4px;
  box-sizing: border-box;
  font-size: 12px;
}

.form-msg-error-gr {
  color: #e02424;
  position: relative;
  top: 0;
  left: 0;
  background-color: #fef2f2;
  width: 100%;
  text-align: left;
  padding: 6px 10px;
  border: 1px solid #fee2e2;
  border-radius: 6px;
  margin-top: 4px;
  height: auto;
  z-index: 2;
  font-size: 12px;
  box-sizing: border-box;
}


/* ═══════════════════════════════════════════════════════════════════════════
   CAMPO REQUERIDO (asterisco)
   ═══════════════════════════════════════════════════════════════════════════ */
.reqField-gs {
  color: #e02424;
  font-size: 14px;
  position: relative;
  top: 0 !important;
  left: 2px;
  height: auto;
  font-weight: 600;
}


/* ═══════════════════════════════════════════════════════════════════════════
   OVERLAY DE BLOQUEO
   ═══════════════════════════════════════════════════════════════════════════ */
.blockfield-gs {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(248, 250, 252, 0.85);
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0f2d5e;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
}


/* ═══════════════════════════════════════════════════════════════════════════
   LABEL DELETE (con icono / clickeable)
   ═══════════════════════════════════════════════════════════════════════════ */
.label-GS-delete {
  font-size: 13px;
  position: relative;
  top: 0;
  left: 0;
  padding: 0;
  font-weight: 600;
  color: #e02424;
  pointer-events: auto;
  transition: color 0.15s ease;
  z-index: 2;
}

.label-GS-delete:hover {
  cursor: pointer;
  color: #b91c1c;
  font-size: 13px !important;
}


/* ═══════════════════════════════════════════════════════════════════════════
   CHECKBOX EN MODAL
   ═══════════════════════════════════════════════════════════════════════════ */
.checkbox-gs {
  height: 16px !important;
  width: 16px;
  cursor: pointer;
  accent-color: #1a56db;
}

.label-checkbox-gs {
  left: 0;
  position: relative;
  color: #0f2d5e;
  font-size: 12px;
  font-weight: 500;
  margin-left: 8px;
}


/* ═══════════════════════════════════════════════════════════════════════════
   MENÚ MULTICARD (tabs dentro de modal)
   ═══════════════════════════════════════════════════════════════════════════ */
.content-multicard-modal-gs {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.menu-multicard-modal-gs {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 20px;
  flex-shrink: 0;
}

.menu-multicard-modal-gs .compact-menu-list {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  left: 0;
  justify-content: flex-start;
  align-items: center;
  list-style-type: none;
  padding: 0;
  margin: 0;
  gap: 0;
}

.menu-multicard-modal-gs .compact-menu-list li {
  flex-grow: 0;
  width: auto;
  height: auto;
  padding: 12px 18px;
  background-color: transparent;
  border-right: none;
  border-bottom: 2px solid transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  color: #64748b;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.menu-multicard-modal-gs .compact-menu-list li:hover {
  color: #0f2d5e;
}

.menu-multicard-modal-gs .compact-menu-list li.active,
.menu-multicard-modal-gs .compact-menu-list li.selected {
  color: #1a56db;
  font-weight: 600;
  border-bottom-color: #1a56db;
}

.head-line-gs {
  display: none;
  /* La línea ahora se hace con border-bottom del menú */
}

.cont-body-multicard-modal-gs {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: stretch;
}


/* ═══════════════════════════════════════════════════════════════════════════
   MODAL DE ELIMINAR (delete-modal-gs)
   ═══════════════════════════════════════════════════════════════════════════ */
.delete-modal-gs {
  color: #e02424;
}

.cont-info-modal-delete-gs {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding: 4px;
  gap: 18px;
}

.cont-message-modal-delete-gs {
  position: relative;
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
}

.txt-message-modal-delete-gs {
  font-size: 14px;
  color: #e02424;
  letter-spacing: 0.02em;
  font-weight: 600;
  text-align: center;
}

.cont-user-modal-delete-gs {
  position: relative;
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background: #fef2f2;
  border: 1px solid #fee2e2;
  border-radius: 8px;
}

.txt-user-modal-delete-gs {
  font-size: 13px;
  color: #334155;
  text-align: center;
  line-height: 1.5;
}

.cont-btn-modal-delete-gs {
  position: relative;
  display: flex;
  width: 100%;
  height: auto;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  padding-top: 18px;
  border-top: 1px solid #e2e8f0;
}

.cont-user-modal-delete {
  word-wrap: break-word !important;
  word-break: break-all !important;
}


/* ═══════════════════════════════════════════════════════════════════════════
   LISTAS DE BÚSQUEDA DESPLEGABLES (search host)
   ═══════════════════════════════════════════════════════════════════════════ */
.container-searchHostGS-list {
  background-color: #ffffff;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  position: absolute;
  display: flex;
  justify-content: center;
  max-height: 200px;
  font-size: 12px;
  top: calc(100% + 4px);
  z-index: 5;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(15, 45, 94, 0.12);
  overflow: hidden;
}

.compact-searchHostGS-list {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  position: relative;
  display: block;
  overflow-y: auto;
  border: none !important;
  border-radius: 8px;
  scrollbar-width: thin;
}

.row-searchHostGS-list {
  background-color: #ffffff;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  cursor: pointer;
  transition: background 0.12s ease;
  box-sizing: border-box;
}

.row-searchHostGS-list:hover {
  background-color: #e8f0fe;
}

.row-searchHostGS-list:last-child {
  border-bottom: none;
}

.cont-row-searchHostGS-txt {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}

.ip-row-searchHostGS {
  color: #1a56db;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 600;
}

.closeListSearchGS {
  position: absolute;
  top: 6px;
  right: 6px;
  left: auto;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e02424;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  background: #fef2f2;
}

.closeListSearchGS:hover {
  background: #fee2e2;
}


/* ── Versión legacy (Mantto) — refinada para no romper visuales viejas ──── */
.container-searchHostMantto-list {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  position: absolute;
  display: flex;
  justify-content: center;
  max-height: 200px;
  font-size: 12px;
  top: calc(100% + 4px);
  z-index: 3;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 25px rgba(15, 45, 94, 0.12);
  overflow: hidden;
}

.compact-searchHostMantto-list {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  position: relative;
  display: block;
  overflow-y: auto;
  border: none !important;
  border-radius: 8px;
  scrollbar-width: thin;
}

.row-searchHostMantto-list {
  background-color: #ffffff;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  color: #334155;
  cursor: pointer;
  transition: background 0.12s ease;
  box-sizing: border-box;
}

.row-searchHostMantto-list:hover {
  background-color: #e8f0fe;
  cursor: pointer;
}

.cont-row-searchHostMantto-txt {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}

.ip-row-searchHostMantto {
  color: #1a56db;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 600;
}

.row-searchHostMantto-list:hover .ip-row-searchHostMantto {
  color: #1a56db;
}

.closeListSearch {
  position: absolute;
  top: 6px;
  right: 6px;
  left: auto;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e02424;
  font-weight: 600;
  font-size: 13px;
  background: #fef2f2;
}

.closeListSearch:hover {
  font-size: 13px;
  cursor: pointer;
  background: #fee2e2;
}


/* ═══════════════════════════════════════════════════════════════════════════
   ELEMENTOS DE RELACIÓN (chips de hosts vinculados)
   ═══════════════════════════════════════════════════════════════════════════ */
.body_info_gs_relation {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  height: 100%;
}

.content-RelationTechDevice_relation-gs {
  position: relative;
  justify-content: center;
  display: flex;
  flex-direction: column;
  height: auto;
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: none;
  background: #ffffff;
  overflow: hidden;
}

.cont-RelationTechDevice-info-gs {
  height: auto;
  width: 100%;
  display: block;
  padding: 12px 0;
}

.cont-RelationTechDevice-search-gs {
  display: flex;
  height: auto;
  padding: 10px 14px;
  gap: 10px;
  align-items: center;
  border-bottom: 1px solid #f1f5f9;
}

.cont-search-relation-RelationTechDevice-gs {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: auto;
  width: 70%;
}

.cont-search-relation-RelationTechDevice-gs .group {
  width: 100%;
}

.cont-search-space-gs {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 10%;
}

.msgErrorRelationGs {
  color: #e02424;
  font-size: 12px;
}

.cont-search-buttons-gs {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: auto;
  width: 20%;
}

.cont-RelationTechDevice-table-relation-gs {
  position: relative;
  height: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding: 4px 0;
}

.content-card-RelationTechDevice-relation-gs {
  position: relative;
  height: auto;
  width: 100%;
  display: block;
  border: none;
  border-radius: 0;
}

.cont-elemen-relation-gs {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 14px;
}

.elemen-relation-gs {
  position: relative;
  width: 100%;
  height: auto;
  min-height: 42px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.elemen-relation-gs:hover {
  border-color: #cbd5e1;
  background: #ffffff;
}

.con-elemen-relation-info-gs {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 90%;
  height: 100%;
  color: #0f2d5e;
  gap: 12px;
  text-align: left;
}

.con-elemen-relation-info-gs .txtIp {
  color: #1a56db;
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-weight: 600;
  width: auto;
  min-width: 90px;
  padding: 2px 8px;
  background: #e8f0fe;
  border-radius: 4px;
}

.con-elemen-relation-info-gs .txtHost {
  color: #0f172a;
  font-size: 13px;
  font-weight: 500;
  width: auto;
  flex: 1 1;
}

.con-elemen-relation-img-gs {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
  height: 100%;
}

.cont-img-field-acciones-gs {
  position: relative;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.cont-img-field-acciones-gs:hover {
  background: #f1f5f9;
}

.img-field-acciones-gs {
  position: relative;
  height: 16px;
}


/* ═══════════════════════════════════════════════════════════════════════════
   FILAS DE INFO (Tech Device)
   ═══════════════════════════════════════════════════════════════════════════ */
.row-RelationTechDevice-info-gs {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 6px 14px;
  gap: 12px;
}

.cont-title-RelationTechDevice-info-gs {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 35%;
  height: auto;
}

.title-RelationTechDevice-info-gs {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  color: #0f2d5e;
  letter-spacing: 0.02em;
}

.cont-box-RelationTechDevice-info-gs {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 65%;
  height: auto;
}

.box-RelationTechDevice-info-gs {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  background: #f8fafc;
  color: #334155;
  border: 1px solid #e2e8f0;
  font-size: 13px;
}


/* ═══════════════════════════════════════════════════════════════════════════
   INPUT RADIO (heredado)
   ═══════════════════════════════════════════════════════════════════════════ */
.form-GS-box .user-box-GS .input-radio-gs {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  font-size: 13px;
  color: #0f172a;
  margin-bottom: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  outline: none;
  background: #ffffff;
  box-sizing: border-box;
}

.input-radio-gs-label {
  font-size: 12px;
  position: relative;
  top: 0;
  color: #64748b;
}


/* ═══════════════════════════════════════════════════════════════════════════
   COMPATIBILIDAD CON CSS VIEJO (Mantto) — Refinado a Clean Blue
   ═══════════════════════════════════════════════════════════════════════════ */
.user-box-Mantto {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  height: auto;
  gap: 6px;
}

.form-Mantto-box {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  gap: 18px;
}

.form-Mantto-box .user-box-Mantto .label-Mantto {
  position: relative;
  top: 0 !important;
  left: 0;
  padding: 0;
  font-size: 12px !important;
  font-weight: 600;
  color: #0f2d5e;
  pointer-events: none;
  transition: none;
}

.form-Mantto-box .user-box-Mantto input:focus~.label-Mantto,
.form-Mantto-box .user-box-Mantto input:valid~.label-Mantto,
.form-Mantto-box .user-box-Mantto .active {
  top: 0 !important;
  left: 0;
  font-size: 12px !important;
  color: #0f2d5e;
}

.form-Mantto-box .user-box-Mantto input {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  font-size: 13px;
  color: #0f172a;
  margin-bottom: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  outline: none;
  background: #ffffff;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.form-Mantto-box .user-box-Mantto input:focus {
  border-color: #1a56db;
  box-shadow: 0 0 0 3px rgba(26, 86, 219, 0.15);
}

.head-card-Mantto {
  position: relative;
  height: auto;
  min-height: 56px;
  width: 100%;
  background: #0f2d5e;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 14px 20px;
  box-sizing: border-box;
}

.checkbox-Mantto {
  height: 16px !important;
  width: 16px;
  cursor: pointer;
  accent-color: #1a56db;
}

.label-checkbox-Mantto {
  left: 0;
  position: relative;
  top: 0;
  color: #0f2d5e;
  font-size: 12px;
  margin-left: 8px;
}

.read {
  background: #f1f5f9;
}


/* ═══════════════════════════════════════════════════════════════════════════
   SOBRESCRITURA DE BOTONES (Action) — Estilo outline gris para disabled
   ─────────────────────────────────────────────────────────────────────────
   Estas reglas sobrescriben las clases que vienen del componente Action.
   Si quieres que el cambio sea más quirúrgico, mueve este bloque al CSS
   propio del componente Action.
   ═══════════════════════════════════════════════════════════════════════════ */

/* Botón principal Azul (Guardar / Crear / Editar) */
.actAzul {
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 18px !important;
  border-radius: 8px !important;
  border: none !important;
  background: #1a56db !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: background 0.15s ease, box-shadow 0.15s ease !important;
  box-shadow: 0 1px 2px rgba(15, 45, 94, 0.1) !important;
  letter-spacing: 0.01em !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
}

.actAzul:hover {
  background: #1e40af !important;
  box-shadow: 0 4px 8px rgba(15, 45, 94, 0.15) !important;
}

/* Botón disabled — outline gris (como pediste) */
.actDisabled {
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 18px !important;
  border-radius: 8px !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
  color: #94a3b8 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  cursor: not-allowed !important;
  transition: none !important;
  box-shadow: none !important;
  letter-spacing: 0.01em !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
}

.actDisabled:hover {
  background: #ffffff !important;
  color: #94a3b8 !important;
}

/* Botón Cancelar — outline azul */
.actCancelar {
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 18px !important;
  border-radius: 8px !important;
  border: 1px solid #1a56db !important;
  background: #ffffff !important;
  color: #1a56db !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: background 0.15s ease !important;
  letter-spacing: 0.01em !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
}

.actCancelar:hover {
  background: #e8f0fe !important;
}

/* Botón Rojo (eliminar / cierre masivo) */
.actRed {
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 18px !important;
  border-radius: 8px !important;
  border: none !important;
  background: #ef4444 !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: background 0.15s ease, box-shadow 0.15s ease !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
  letter-spacing: 0.01em !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
}

.actRed:hover {
  background: #dc2626 !important;
  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.2) !important;
}


/* ═══════════════════════════════════════════════════════════════════════════
   RESPONSIVE — Horizontal Móvil
   ═══════════════════════════════════════════════════════════════════════════ */
@media (min-width: 500px) and (max-width: 900px) {



  .content-card-modal-gs {
    padding: 18px;
  }

  .form-GS-box .user-box-GS input {
    padding: 0 10px;
    font-size: 13px;
  }

  .form-GS-box .user-box-GS .label-GS {
    top: 0;
    font-size: 12px !important;
  }

  .cont-elemen-relation-gs {
    padding: 4px 10px;
  }
}


/* ═══════════════════════════════════════════════════════════════════════════
   RESPONSIVE — Móvil
   ═══════════════════════════════════════════════════════════════════════════ */
@media (max-width: 500px) {

  .card-modal-gs,
  .card-modal-gs.modal-verificate {
    width: 96% !important;
    max-width: 96% !important;
    height: auto !important;
    max-height: 95vh !important;
  }

  .head-card-modal-gs {
    padding: 12px 14px;
    min-height: 50px;
  }

  .title-head-card-modal-gs {
    font-size: 14px;
  }

  .content-card-modal-gs {
    padding: 16px;
  }

  .form-GS-box {
    gap: 14px;
  }

  .form-GS-box .user-box-GS input {
    padding: 0 10px;
    font-size: 13px;
    height: 36px;
  }

  .form-GS-box .user-box-GS .label-GS {
    top: 0;
    font-size: 12px !important;
  }

  .form-GS-box .user-box-GS:last-child {
    flex-direction: column;
    align-items: stretch;
  }

  .actAzul,
  .actDisabled,
  .actCancelar,
  .actRed {
    width: 100% !important;
  }

  .cont-elemen-relation-gs {
    height: auto;
    padding: 4px 8px;
  }

  .row-table-portafolio div {
    font-size: 12px;
  }

  .tabs-roles {
    transform: scale(1) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/portafolio-components/styles/ModalCreateService.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;gFAsBgF;;;AAGhF,+EAA+E;AAC/E;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB;;qBAEmB;EACnB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb;qCACmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,uBAAuB;EACvB,iCAAiC;AACnC;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,uBAAuB;EACvB,QAAQ;AACV;;AAEA,kFAAkF;AAClF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;qDACqD;AACrD;;;EAGE,iBAAiB;EACjB,OAAO;EACP,0BAA0B;EAC1B,cAAc;AAChB;;;AAGA;;gFAEgF;AAChF;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0DAA0D;EAC1D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;;AAGA;;gFAEgF;AAChF;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA,qDAAqD;AACrD;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,eAAe;EACf,sBAAsB;AACxB;;;AAGA;;gFAEgF;AAChF;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,0BAA0B;EAC1B,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;;gFAEgF;AAChF;EACE,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;;AAGA;;gFAEgF;AAChF;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,OAAO;EACP,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;;AAGA;;gFAEgF;AAChF;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;;AAGA;;gFAEgF;AAChF;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,8EAA8E;AAC9E;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2DAA2D;EAC3D,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;;AAGA;;gFAEgF;AAChF;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,cAAc;AAChB;;;AAGA;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,OAAO;EACP,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;EACjB,OAAO;EACP,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;;;;;gFAMgF;;AAEhF,oDAAoD;AACpD;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,mEAAmE;EACnE,sDAAsD;EACtD,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uDAAuD;AACzD;;AAEA,iDAAiD;AACjD;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,4CAA4C;EAC5C,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,0CAA0C;AAC1C;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,mEAAmE;EACnE,oDAAoD;EACpD,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uDAAuD;AACzD;;;AAGA;;gFAEgF;AAChF;;;;EAIE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,MAAM;IACN,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;;AAGA;;gFAEgF;AAChF;;EAEE;;IAEE,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,MAAM;IACN,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;;IAIE,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════════════\r\n   SISTEMA DE MODALES — CLEAN BLUE\r\n   ═══════════════════════════════════════════════════════════════════════════\r\n   Este CSS rediseña las clases base que comparten TODOS los modales\r\n   `card-modal-gs`. Cambiar este archivo aplica el nuevo estilo a:\r\n     - ModalCreateService\r\n     - Cualquier otro modal que use .card-modal-gs / .head-card-modal-gs /\r\n       .content-card-modal-gs / .form-GS-box / .user-box-GS / .label-GS\r\n   \r\n   Paleta usada:\r\n     --cb-blue:        #1a56db   (primario)\r\n     --cb-blue-dark:   #0f2d5e   (header azul marino)\r\n     --cb-blue-soft:   #e8f0fe   (focus, fondos suaves)\r\n     --cb-text:        #0f172a\r\n     --cb-text-2:      #334155\r\n     --cb-text-3:      #64748b\r\n     --cb-border:      #e2e8f0\r\n     --cb-bg:          #f8fafc\r\n     --cb-bg-2:        #f1f5f9\r\n     --cb-white:       #ffffff\r\n     --cb-red:         #e02424\r\n     --cb-red-soft:    #fef2f2\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n\r\n\r\n/* ── Compatibilidad con clases antiguas (no se tocan) ────────────────────── */\r\n.card-users.modal-verificate {\r\n  width: 100% !important;\r\n  height: 99% !important;\r\n}\r\n\r\n.content-card-users {\r\n  height: 94%;\r\n}\r\n\r\n.txt-title-user-box-Mantto.modal-verificate {\r\n  text-align: center;\r\n  word-wrap: break-word;\r\n  width: 80%;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   FONDO OSCURO DEL MODAL\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.modal-GS-content {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(15, 23, 42, 0.45);\r\n  backdrop-filter: blur(2px);\r\n  -webkit-backdrop-filter: blur(2px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   TARJETA DEL MODAL\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.card-modal-gs {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* width: 90%;\r\n  max-width: 560px;\r\n  max-height: 92vh; */\r\n  z-index: 1;\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  outline: none;\r\n  box-shadow: 0 20px 60px rgba(15, 45, 94, 0.25),\r\n    0 4px 12px rgba(15, 45, 94, 0.08);\r\n}\r\n\r\n.card-modal-gs.modal-verificate {\r\n  width: 100% !important;\r\n  /* max-width: 560px !important; */\r\n  height: 100% !important;\r\n  /* max-height: 92vh !important; */\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   HEADER AZUL MARINO\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.head-card-modal-gs {\r\n  position: relative;\r\n  height: auto;\r\n  min-height: 56px;\r\n  width: 100%;\r\n  background: #0f2d5e;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  padding: 14px 20px;\r\n  flex-shrink: 0;\r\n  gap: 12px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.title-head-card-modal-gs {\r\n  color: #ffffff;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.02em;\r\n  text-transform: none;\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Botón X opcional — agregar al JSX con esta clase si se desea: */\r\n.close-card-modal-gs {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 8px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: none;\r\n  color: #ffffff;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 1;\r\n  transition: background 0.15s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.close-card-modal-gs:hover {\r\n  background: rgba(255, 255, 255, 0.18);\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   CUERPO DEL MODAL\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.content-card-modal-gs {\r\n  position: relative;\r\n  height: auto;\r\n  flex: 1;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: stretch;\r\n  padding: 24px;\r\n  box-sizing: border-box;\r\n  background: #f8fafc;\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   FORMULARIO — Layout vertical limpio con gap (no más alturas en %)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.form-GS-box {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n  width: 100%;\r\n  max-width: 480px;\r\n  height: auto;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   CAMPO DE FORMULARIO — Label arriba, input abajo (altura fija 36px)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.form-GS-box .user-box-GS {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  height: auto !important;\r\n  gap: 6px;\r\n}\r\n\r\n/* El último user-box-GS suele ser el contenedor de botones — más espacio arriba */\r\n.form-GS-box .user-box-GS:last-child {\r\n  flex-direction: row;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 14px;\r\n  padding-top: 18px;\r\n  border-top: 1px solid #e2e8f0;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   LABEL — Posición normal arriba del input (no más absolute flotante)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.form-GS-box .user-box-GS .label-GS {\r\n  position: relative;\r\n  top: 0;\r\n  left: 0;\r\n  padding: 0;\r\n  font-size: 12px !important;\r\n  font-weight: 600;\r\n  color: #0f2d5e;\r\n  pointer-events: none;\r\n  transition: none;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n/* Estados focus/valid que antes movían el label — ahora no hace falta animar\r\n   pero los dejamos compatibles para no romper nada */\r\n.form-GS-box .user-box-GS input:focus~.label-GS,\r\n.form-GS-box .user-box-GS input:valid~.label-GS,\r\n.form-GS-box .user-box-GS .active {\r\n  top: 0 !important;\r\n  left: 0;\r\n  font-size: 12px !important;\r\n  color: #0f2d5e;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   INPUTS — Altura fija, borde fino, focus azul\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.form-GS-box .user-box-GS input {\r\n  width: 100%;\r\n  height: 36px;\r\n  padding: 0 12px;\r\n  font-size: 13px;\r\n  color: #0f172a;\r\n  border: 1px solid #e2e8f0;\r\n  border-right: 1px solid #e2e8f0;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  background: #ffffff;\r\n  box-sizing: border-box;\r\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\r\n  margin: 0;\r\n}\r\n\r\n.form-GS-box .user-box-GS input::placeholder {\r\n  color: #94a3b8;\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n}\r\n\r\n.form-GS-box .user-box-GS input:hover:not(:disabled) {\r\n  border-color: #cbd5e1;\r\n}\r\n\r\n.form-GS-box .user-box-GS input:focus {\r\n  border-color: #1a56db;\r\n  box-shadow: 0 0 0 3px rgba(26, 86, 219, 0.15);\r\n}\r\n\r\n.form-GS-box .user-box-GS input:disabled {\r\n  background: #f1f5f9;\r\n  color: #64748b;\r\n  cursor: not-allowed;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   MENSAJE DE ERROR\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.form-msg-error-gs {\r\n  display: block;\r\n  margin-top: 4px;\r\n  padding: 6px 10px;\r\n  background: #fef2f2;\r\n  border: 1px solid #fee2e2;\r\n  color: #e02424;\r\n  font-size: 12px;\r\n  border-radius: 6px;\r\n  text-align: left;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n/* Versión anterior (banner ancho) — compatibilidad */\r\n.form-msg-error {\r\n  color: #e02424;\r\n  position: relative;\r\n  top: 0;\r\n  left: 0;\r\n  background-color: #fef2f2;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 6px 10px;\r\n  border: 1px solid #fee2e2;\r\n  border-radius: 6px;\r\n  margin-top: 4px;\r\n  box-sizing: border-box;\r\n  font-size: 12px;\r\n}\r\n\r\n.form-msg-error-gr {\r\n  color: #e02424;\r\n  position: relative;\r\n  top: 0;\r\n  left: 0;\r\n  background-color: #fef2f2;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 6px 10px;\r\n  border: 1px solid #fee2e2;\r\n  border-radius: 6px;\r\n  margin-top: 4px;\r\n  height: auto;\r\n  z-index: 2;\r\n  font-size: 12px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   CAMPO REQUERIDO (asterisco)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.reqField-gs {\r\n  color: #e02424;\r\n  font-size: 14px;\r\n  position: relative;\r\n  top: 0 !important;\r\n  left: 2px;\r\n  height: auto;\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   OVERLAY DE BLOQUEO\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.blockfield-gs {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(248, 250, 252, 0.85);\r\n  backdrop-filter: blur(1px);\r\n  -webkit-backdrop-filter: blur(1px);\r\n  z-index: 100;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #0f2d5e;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  border-radius: 8px;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   LABEL DELETE (con icono / clickeable)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.label-GS-delete {\r\n  font-size: 13px;\r\n  position: relative;\r\n  top: 0;\r\n  left: 0;\r\n  padding: 0;\r\n  font-weight: 600;\r\n  color: #e02424;\r\n  pointer-events: auto;\r\n  transition: color 0.15s ease;\r\n  z-index: 2;\r\n}\r\n\r\n.label-GS-delete:hover {\r\n  cursor: pointer;\r\n  color: #b91c1c;\r\n  font-size: 13px !important;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   CHECKBOX EN MODAL\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.checkbox-gs {\r\n  height: 16px !important;\r\n  width: 16px;\r\n  cursor: pointer;\r\n  accent-color: #1a56db;\r\n}\r\n\r\n.label-checkbox-gs {\r\n  left: 0;\r\n  position: relative;\r\n  color: #0f2d5e;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  margin-left: 8px;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   MENÚ MULTICARD (tabs dentro de modal)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.content-multicard-modal-gs {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: stretch;\r\n}\r\n\r\n.menu-multicard-modal-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: auto;\r\n  background: #ffffff;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  padding: 0 20px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.menu-multicard-modal-gs .compact-menu-list {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  left: 0;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  gap: 0;\r\n}\r\n\r\n.menu-multicard-modal-gs .compact-menu-list li {\r\n  flex-grow: 0;\r\n  width: auto;\r\n  height: auto;\r\n  padding: 12px 18px;\r\n  background-color: transparent;\r\n  border-right: none;\r\n  border-bottom: 2px solid transparent;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  color: #64748b;\r\n  transition: color 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.menu-multicard-modal-gs .compact-menu-list li:hover {\r\n  color: #0f2d5e;\r\n}\r\n\r\n.menu-multicard-modal-gs .compact-menu-list li.active,\r\n.menu-multicard-modal-gs .compact-menu-list li.selected {\r\n  color: #1a56db;\r\n  font-weight: 600;\r\n  border-bottom-color: #1a56db;\r\n}\r\n\r\n.head-line-gs {\r\n  display: none;\r\n  /* La línea ahora se hace con border-bottom del menú */\r\n}\r\n\r\n.cont-body-multicard-modal-gs {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: stretch;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   MODAL DE ELIMINAR (delete-modal-gs)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.delete-modal-gs {\r\n  color: #e02424;\r\n}\r\n\r\n.cont-info-modal-delete-gs {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: auto;\r\n  padding: 4px;\r\n  gap: 18px;\r\n}\r\n\r\n.cont-message-modal-delete-gs {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: auto;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 8px 0;\r\n}\r\n\r\n.txt-message-modal-delete-gs {\r\n  font-size: 14px;\r\n  color: #e02424;\r\n  letter-spacing: 0.02em;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n.cont-user-modal-delete-gs {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: auto;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 16px;\r\n  background: #fef2f2;\r\n  border: 1px solid #fee2e2;\r\n  border-radius: 8px;\r\n}\r\n\r\n.txt-user-modal-delete-gs {\r\n  font-size: 13px;\r\n  color: #334155;\r\n  text-align: center;\r\n  line-height: 1.5;\r\n}\r\n\r\n.cont-btn-modal-delete-gs {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: auto;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 8px;\r\n  padding-top: 18px;\r\n  border-top: 1px solid #e2e8f0;\r\n}\r\n\r\n.cont-user-modal-delete {\r\n  word-wrap: break-word !important;\r\n  word-break: break-all !important;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   LISTAS DE BÚSQUEDA DESPLEGABLES (search host)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.container-searchHostGS-list {\r\n  background-color: #ffffff;\r\n  width: 100%;\r\n  height: auto;\r\n  box-sizing: border-box;\r\n  position: absolute;\r\n  display: flex;\r\n  justify-content: center;\r\n  max-height: 200px;\r\n  font-size: 12px;\r\n  top: calc(100% + 4px);\r\n  z-index: 5;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  box-shadow: 0 10px 25px rgba(15, 45, 94, 0.12);\r\n  overflow: hidden;\r\n}\r\n\r\n.compact-searchHostGS-list {\r\n  width: 100%;\r\n  height: auto;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  display: block;\r\n  overflow-y: auto;\r\n  border: none !important;\r\n  border-radius: 8px;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.row-searchHostGS-list {\r\n  background-color: #ffffff;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 36px;\r\n  padding: 0 12px;\r\n  border-bottom: 1px solid #f1f5f9;\r\n  color: #334155;\r\n  cursor: pointer;\r\n  transition: background 0.12s ease;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.row-searchHostGS-list:hover {\r\n  background-color: #e8f0fe;\r\n}\r\n\r\n.row-searchHostGS-list:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.cont-row-searchHostGS-txt {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.ip-row-searchHostGS {\r\n  color: #1a56db;\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.closeListSearchGS {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 6px;\r\n  left: auto;\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #e02424;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  background: #fef2f2;\r\n}\r\n\r\n.closeListSearchGS:hover {\r\n  background: #fee2e2;\r\n}\r\n\r\n\r\n/* ── Versión legacy (Mantto) — refinada para no romper visuales viejas ──── */\r\n.container-searchHostMantto-list {\r\n  width: 100%;\r\n  height: auto;\r\n  box-sizing: border-box;\r\n  position: absolute;\r\n  display: flex;\r\n  justify-content: center;\r\n  max-height: 200px;\r\n  font-size: 12px;\r\n  top: calc(100% + 4px);\r\n  z-index: 3;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  background: #ffffff;\r\n  box-shadow: 0 10px 25px rgba(15, 45, 94, 0.12);\r\n  overflow: hidden;\r\n}\r\n\r\n.compact-searchHostMantto-list {\r\n  width: 100%;\r\n  height: auto;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  display: block;\r\n  overflow-y: auto;\r\n  border: none !important;\r\n  border-radius: 8px;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.row-searchHostMantto-list {\r\n  background-color: #ffffff;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 36px;\r\n  padding: 0 12px;\r\n  color: #334155;\r\n  cursor: pointer;\r\n  transition: background 0.12s ease;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.row-searchHostMantto-list:hover {\r\n  background-color: #e8f0fe;\r\n  cursor: pointer;\r\n}\r\n\r\n.cont-row-searchHostMantto-txt {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.ip-row-searchHostMantto {\r\n  color: #1a56db;\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.row-searchHostMantto-list:hover .ip-row-searchHostMantto {\r\n  color: #1a56db;\r\n}\r\n\r\n.closeListSearch {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 6px;\r\n  left: auto;\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #e02424;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  background: #fef2f2;\r\n}\r\n\r\n.closeListSearch:hover {\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  background: #fee2e2;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   ELEMENTOS DE RELACIÓN (chips de hosts vinculados)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.body_info_gs_relation {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.content-RelationTechDevice_relation-gs {\r\n  position: relative;\r\n  justify-content: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: auto;\r\n  width: 100%;\r\n  border-radius: 10px;\r\n  border: 1px solid #e2e8f0;\r\n  box-shadow: none;\r\n  background: #ffffff;\r\n  overflow: hidden;\r\n}\r\n\r\n.cont-RelationTechDevice-info-gs {\r\n  height: auto;\r\n  width: 100%;\r\n  display: block;\r\n  padding: 12px 0;\r\n}\r\n\r\n.cont-RelationTechDevice-search-gs {\r\n  display: flex;\r\n  height: auto;\r\n  padding: 10px 14px;\r\n  gap: 10px;\r\n  align-items: center;\r\n  border-bottom: 1px solid #f1f5f9;\r\n}\r\n\r\n.cont-search-relation-RelationTechDevice-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  height: auto;\r\n  width: 70%;\r\n}\r\n\r\n.cont-search-relation-RelationTechDevice-gs .group {\r\n  width: 100%;\r\n}\r\n\r\n.cont-search-space-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: auto;\r\n  width: 10%;\r\n}\r\n\r\n.msgErrorRelationGs {\r\n  color: #e02424;\r\n  font-size: 12px;\r\n}\r\n\r\n.cont-search-buttons-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  height: auto;\r\n  width: 20%;\r\n}\r\n\r\n.cont-RelationTechDevice-table-relation-gs {\r\n  position: relative;\r\n  height: auto;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: stretch;\r\n  padding: 4px 0;\r\n}\r\n\r\n.content-card-RelationTechDevice-relation-gs {\r\n  position: relative;\r\n  height: auto;\r\n  width: 100%;\r\n  display: block;\r\n  border: none;\r\n  border-radius: 0;\r\n}\r\n\r\n.cont-elemen-relation-gs {\r\n  position: relative;\r\n  width: 100%;\r\n  height: auto;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 6px 14px;\r\n}\r\n\r\n.elemen-relation-gs {\r\n  position: relative;\r\n  width: 100%;\r\n  height: auto;\r\n  min-height: 42px;\r\n  border-radius: 8px;\r\n  border: 1px solid #e2e8f0;\r\n  background: #f8fafc;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 6px 12px;\r\n  transition: border-color 0.15s ease, background 0.15s ease;\r\n}\r\n\r\n.elemen-relation-gs:hover {\r\n  border-color: #cbd5e1;\r\n  background: #ffffff;\r\n}\r\n\r\n.con-elemen-relation-info-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 90%;\r\n  height: 100%;\r\n  color: #0f2d5e;\r\n  gap: 12px;\r\n  text-align: left;\r\n}\r\n\r\n.con-elemen-relation-info-gs .txtIp {\r\n  color: #1a56db;\r\n  font-size: 12px;\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\r\n  font-weight: 600;\r\n  width: auto;\r\n  min-width: 90px;\r\n  padding: 2px 8px;\r\n  background: #e8f0fe;\r\n  border-radius: 4px;\r\n}\r\n\r\n.con-elemen-relation-info-gs .txtHost {\r\n  color: #0f172a;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  width: auto;\r\n  flex: 1;\r\n}\r\n\r\n.con-elemen-relation-img-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 10%;\r\n  height: 100%;\r\n}\r\n\r\n.cont-img-field-acciones-gs {\r\n  position: relative;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.cont-img-field-acciones-gs:hover {\r\n  background: #f1f5f9;\r\n}\r\n\r\n.img-field-acciones-gs {\r\n  position: relative;\r\n  height: 16px;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   FILAS DE INFO (Tech Device)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.row-RelationTechDevice-info-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: auto;\r\n  padding: 6px 14px;\r\n  gap: 12px;\r\n}\r\n\r\n.cont-title-RelationTechDevice-info-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 35%;\r\n  height: auto;\r\n}\r\n\r\n.title-RelationTechDevice-info-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: auto;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  text-align: left;\r\n  color: #0f2d5e;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.cont-box-RelationTechDevice-info-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 65%;\r\n  height: auto;\r\n}\r\n\r\n.box-RelationTechDevice-info-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 32px;\r\n  padding: 0 10px;\r\n  border-radius: 6px;\r\n  background: #f8fafc;\r\n  color: #334155;\r\n  border: 1px solid #e2e8f0;\r\n  font-size: 13px;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   INPUT RADIO (heredado)\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.form-GS-box .user-box-GS .input-radio-gs {\r\n  width: 100%;\r\n  height: 36px;\r\n  padding: 0 10px;\r\n  font-size: 13px;\r\n  color: #0f172a;\r\n  margin-bottom: 0;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  background: #ffffff;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.input-radio-gs-label {\r\n  font-size: 12px;\r\n  position: relative;\r\n  top: 0;\r\n  color: #64748b;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   COMPATIBILIDAD CON CSS VIEJO (Mantto) — Refinado a Clean Blue\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n.user-box-Mantto {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  height: auto;\r\n  gap: 6px;\r\n}\r\n\r\n.form-Mantto-box {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: auto;\r\n  gap: 18px;\r\n}\r\n\r\n.form-Mantto-box .user-box-Mantto .label-Mantto {\r\n  position: relative;\r\n  top: 0 !important;\r\n  left: 0;\r\n  padding: 0;\r\n  font-size: 12px !important;\r\n  font-weight: 600;\r\n  color: #0f2d5e;\r\n  pointer-events: none;\r\n  transition: none;\r\n}\r\n\r\n.form-Mantto-box .user-box-Mantto input:focus~.label-Mantto,\r\n.form-Mantto-box .user-box-Mantto input:valid~.label-Mantto,\r\n.form-Mantto-box .user-box-Mantto .active {\r\n  top: 0 !important;\r\n  left: 0;\r\n  font-size: 12px !important;\r\n  color: #0f2d5e;\r\n}\r\n\r\n.form-Mantto-box .user-box-Mantto input {\r\n  width: 100%;\r\n  height: 36px;\r\n  padding: 0 12px;\r\n  font-size: 13px;\r\n  color: #0f172a;\r\n  margin-bottom: 0;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  background: #ffffff;\r\n  box-sizing: border-box;\r\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.form-Mantto-box .user-box-Mantto input:focus {\r\n  border-color: #1a56db;\r\n  box-shadow: 0 0 0 3px rgba(26, 86, 219, 0.15);\r\n}\r\n\r\n.head-card-Mantto {\r\n  position: relative;\r\n  height: auto;\r\n  min-height: 56px;\r\n  width: 100%;\r\n  background: #0f2d5e;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  padding: 14px 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.checkbox-Mantto {\r\n  height: 16px !important;\r\n  width: 16px;\r\n  cursor: pointer;\r\n  accent-color: #1a56db;\r\n}\r\n\r\n.label-checkbox-Mantto {\r\n  left: 0;\r\n  position: relative;\r\n  top: 0;\r\n  color: #0f2d5e;\r\n  font-size: 12px;\r\n  margin-left: 8px;\r\n}\r\n\r\n.read {\r\n  background: #f1f5f9;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   SOBRESCRITURA DE BOTONES (Action) — Estilo outline gris para disabled\r\n   ─────────────────────────────────────────────────────────────────────────\r\n   Estas reglas sobrescriben las clases que vienen del componente Action.\r\n   Si quieres que el cambio sea más quirúrgico, mueve este bloque al CSS\r\n   propio del componente Action.\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n\r\n/* Botón principal Azul (Guardar / Crear / Editar) */\r\n.actAzul {\r\n  height: 36px !important;\r\n  min-height: 36px !important;\r\n  padding: 0 18px !important;\r\n  border-radius: 8px !important;\r\n  border: none !important;\r\n  background: #1a56db !important;\r\n  color: #ffffff !important;\r\n  font-size: 13px !important;\r\n  font-weight: 600 !important;\r\n  cursor: pointer !important;\r\n  transition: background 0.15s ease, box-shadow 0.15s ease !important;\r\n  box-shadow: 0 1px 2px rgba(15, 45, 94, 0.1) !important;\r\n  letter-spacing: 0.01em !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  gap: 6px !important;\r\n}\r\n\r\n.actAzul:hover {\r\n  background: #1e40af !important;\r\n  box-shadow: 0 4px 8px rgba(15, 45, 94, 0.15) !important;\r\n}\r\n\r\n/* Botón disabled — outline gris (como pediste) */\r\n.actDisabled {\r\n  height: 36px !important;\r\n  min-height: 36px !important;\r\n  padding: 0 18px !important;\r\n  border-radius: 8px !important;\r\n  border: 1px solid #e2e8f0 !important;\r\n  background: #ffffff !important;\r\n  color: #94a3b8 !important;\r\n  font-size: 13px !important;\r\n  font-weight: 600 !important;\r\n  cursor: not-allowed !important;\r\n  transition: none !important;\r\n  box-shadow: none !important;\r\n  letter-spacing: 0.01em !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  gap: 6px !important;\r\n}\r\n\r\n.actDisabled:hover {\r\n  background: #ffffff !important;\r\n  color: #94a3b8 !important;\r\n}\r\n\r\n/* Botón Cancelar — outline azul */\r\n.actCancelar {\r\n  height: 36px !important;\r\n  min-height: 36px !important;\r\n  padding: 0 18px !important;\r\n  border-radius: 8px !important;\r\n  border: 1px solid #1a56db !important;\r\n  background: #ffffff !important;\r\n  color: #1a56db !important;\r\n  font-size: 13px !important;\r\n  font-weight: 600 !important;\r\n  cursor: pointer !important;\r\n  transition: background 0.15s ease !important;\r\n  letter-spacing: 0.01em !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  gap: 6px !important;\r\n}\r\n\r\n.actCancelar:hover {\r\n  background: #e8f0fe !important;\r\n}\r\n\r\n/* Botón Rojo (eliminar / cierre masivo) */\r\n.actRed {\r\n  height: 36px !important;\r\n  min-height: 36px !important;\r\n  padding: 0 18px !important;\r\n  border-radius: 8px !important;\r\n  border: none !important;\r\n  background: #ef4444 !important;\r\n  color: #ffffff !important;\r\n  font-size: 13px !important;\r\n  font-weight: 600 !important;\r\n  cursor: pointer !important;\r\n  transition: background 0.15s ease, box-shadow 0.15s ease !important;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;\r\n  letter-spacing: 0.01em !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  gap: 6px !important;\r\n}\r\n\r\n.actRed:hover {\r\n  background: #dc2626 !important;\r\n  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.2) !important;\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   RESPONSIVE — Horizontal Móvil\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n@media (min-width: 500px) and (max-width: 900px) {\r\n\r\n\r\n\r\n  .content-card-modal-gs {\r\n    padding: 18px;\r\n  }\r\n\r\n  .form-GS-box .user-box-GS input {\r\n    padding: 0 10px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .form-GS-box .user-box-GS .label-GS {\r\n    top: 0;\r\n    font-size: 12px !important;\r\n  }\r\n\r\n  .cont-elemen-relation-gs {\r\n    padding: 4px 10px;\r\n  }\r\n}\r\n\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   RESPONSIVE — Móvil\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n@media (max-width: 500px) {\r\n\r\n  .card-modal-gs,\r\n  .card-modal-gs.modal-verificate {\r\n    width: 96% !important;\r\n    max-width: 96% !important;\r\n    height: auto !important;\r\n    max-height: 95vh !important;\r\n  }\r\n\r\n  .head-card-modal-gs {\r\n    padding: 12px 14px;\r\n    min-height: 50px;\r\n  }\r\n\r\n  .title-head-card-modal-gs {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .content-card-modal-gs {\r\n    padding: 16px;\r\n  }\r\n\r\n  .form-GS-box {\r\n    gap: 14px;\r\n  }\r\n\r\n  .form-GS-box .user-box-GS input {\r\n    padding: 0 10px;\r\n    font-size: 13px;\r\n    height: 36px;\r\n  }\r\n\r\n  .form-GS-box .user-box-GS .label-GS {\r\n    top: 0;\r\n    font-size: 12px !important;\r\n  }\r\n\r\n  .form-GS-box .user-box-GS:last-child {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .actAzul,\r\n  .actDisabled,\r\n  .actCancelar,\r\n  .actRed {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .cont-elemen-relation-gs {\r\n    height: auto;\r\n    padding: 4px 8px;\r\n  }\r\n\r\n  .row-table-portafolio div {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .tabs-roles {\r\n    transform: scale(1) !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
